import React, { useEffect, useState } from "react";

const ModalComponent = ({
  modalId,
  modalContent,
  mainheading,
  subHeading,
  onClose,
  openModal,
  isHeaderHide,
  isExtralarge,
  isLarge,
  modalContentNotinbody,
}) => {
  const [maxHeight, setMaxHeight] = useState("95vh");

  useEffect(() => {
    const updateHeight = () => {
      setMaxHeight(`${window.innerHeight * 0.9}px`);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <>
      <div
        className={`modal fade ${openModal ? "show" : ""}`}
        id={modalId}
        style={{
          display: openModal ? "flex" : "none", // changed from "block"
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: openModal ? "0px" : "",
          minHeight: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // optional backdrop
        }}
        // style={{
        //   display: openModal ? "block" : "none",
        //   paddingLeft: openModal ? "0px" : "",
        // }}
      >
        <div
          className={`modal-dialog modal-dialog-centered ${
            isExtralarge ? "modal-xxl" : isLarge ? "modal-xl" : "auto"
          }`}
          style={{
            maxWidth: isExtralarge ? "90vw" : isLarge ? "70vw" : "auto",
            minWidth: isExtralarge ? "90vw":"50vw"
          }}
        >
          <div className="modal-content">
            {!isHeaderHide && (
              <div className="modal-header">
                <h3 className="modal-title text-blue">{mainheading}</h3>
                <p className="mb-0">{subHeading}</p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={onClose}
                ></button>
              </div>
            )}
            {!modalContentNotinbody ? (
              <div
                className="modal-body"
                style={{
                  overflowY: "auto",
                  maxHeight: maxHeight,
                }}
              >
                {modalContent}
              </div>
            ) : (
              <>{modalContent}</>
            )}
          </div>
        </div>
      </div>
      {openModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default ModalComponent;
